<div class="drawer-backdrop" (click)="onClose()"></div>
<div class="widgets-right-drawer">
    <div class="drawer-header">
        <div class="title-group">
            <img class="widgets-icon" src="assets/icons/img-apps-add.svg" />
            <div class="widgets-title">Add Widgets</div>
        </div>
        <div class="edit-group">
            <button class="close-drawer-btn" (click)="onClose()">
                <img src="assets/icons/close.svg" alt="Close" />
            </button>
        </div>
    </div>

    <div *ngIf="isAllWidgetsActive" class="no-widgets-message"
        style="color: red; text-align: center; margin-top: 20px;">
        All widgets are currently active
    </div>

    <div class="widgets-scroll-area">
        <div class="widgets-grid">
            <!-- ALL SMALL WIDGETS FIRST (INCLUDING EXPENSE TRACKER) -->

            <div class="widget-item" *ngIf="!isWidgetActive('networthtrend')">
                <app-net-worth-trend-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('networthtrend')"></app-net-worth-trend-widget>
            </div>
            <div class="widget-item" *ngIf="!isWidgetActive('cashflowpreview')">
                <app-cash-flow-preview-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('cashflowpreview')"></app-cash-flow-preview-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('savings')">
                <app-savings-goal-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('savings')"></app-savings-goal-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('spending')">
                <app-spending-snapshot-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('spending')"></app-spending-snapshot-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('aiadvice')">
                <app-ai-advice-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('aiadvice')"></app-ai-advice-widget>
            </div>
            <div class="widget-item" *ngIf="!isWidgetActive('aichat')">
                <app-ai-chat-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('aichat')"></app-ai-chat-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('debts')">
                <app-debts-summary-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('debts')"></app-debts-summary-widget>
            </div>


            <div class="widget-item" *ngIf="!isWidgetActive('bills')">
                <app-upcoming-bills-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('bills')"></app-upcoming-bills-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('budget')">
                <app-budget-status [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('budget')"></app-budget-status>
            </div>
            <div class="widget-item" *ngIf="!isWidgetActive('expensetotal')">
                <app-expense-total-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('expensetotal')"></app-expense-total-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('investmentoverview')">
                <app-investment-overview-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('investmentoverview')"></app-investment-overview-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('expensetracker')">
                <app-expense-tracker [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('expensetracker')"></app-expense-tracker>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('balance')">
                <app-total-balance-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('balance')"></app-total-balance-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('todayexpensetotal')">
                <app-todays-expense-total [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('todayexpensetotal')"></app-todays-expense-total>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('lifetimeexpense')">
                <app-lifetime-expense [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('lifetimeexpense')"></app-lifetime-expense>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('energyexpense')">
                <app-energy-expense [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('energyexpense')"></app-energy-expense>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('loans')">
                <app-loans-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('loans')"></app-loans-widget>
            </div>

            <div class="widget-item" *ngIf="!isWidgetActive('investmentvalue')">
                <app-investment-value-widget [size]="'small'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('investmentvalue')"></app-investment-value-widget>
            </div>

            <!-- ALL MEDIUM WIDGETS SECOND (FULL WIDTH) -->

            <!-- <div class="widget-item medium-item">
                <app-total-balance-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('balance')"></app-total-balance-widget>
            </div>

             <div class="widget-item medium-item">
                <app-todays-expense-total [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('todayexpensetotal')"></app-todays-expense-total>
            </div> -->

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('mycards')">
                <app-my-cards-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('mycards')"></app-my-cards-widget>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('accountsummary')">
                <app-account-summary [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('accountsummary')"></app-account-summary>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('dealsoffers')">
                <app-deals-offers-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('dealsoffers')"></app-deals-offers-widget>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('loanoffers')">
                <app-loan-offers-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('loanoffers')"></app-loan-offers-widget>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('cardoffers')">
                <app-card-offers-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('cardoffers')"></app-card-offers-widget>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('insurance')">
                <app-insurance-offers-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('insurance')"></app-insurance-offers-widget>
            </div>

            <!-- <div class="widget-item medium-item" *ngIf="!isWidgetActive('loans')">
                <app-loans-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('loans')"></app-loans-widget>
            </div>

            <div class="widget-item medium-item" *ngIf="!isWidgetActive('investmentvalue')">
                <app-investment-value-widget [size]="'medium'" [isAddMode]="isAddMode"
                    (addWidget)="onAddWidget('investmentvalue')"></app-investment-value-widget>
            </div> -->
        </div>
    </div>
</div>